<template>
    <div class="d-flex flex-column justify-content-center">
        <div class="w-100 pb-2">
            <label
                for="buttonSize"
                class="font-14"
            >
                Tamanho do Botão
            </label>

            <select
                name="buttonSize"
                id="buttonSize"
                class="form-control"
                v-model="item.frameContent.settings.size"
                @change="onChangeButtonSize"
            >
                <option v-for="size in buttonSizes" :key="size.value" :value="size.value">
                    {{ size.name }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingFrameButtonSize',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            buttonSizes: {
                1: { name: "Automatico", value: 'normal' },
                2: { name: "Linha completa", value: 'btn-block' }
            },
        }
    },
    methods: {
        onChangeButtonSize() {
            this.$emit('onChangeButtonSize', this.item)
        },
    },
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameButtonSize.vue